/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import styled from 'styled-components';

import RenderPhoneField from '../../../utils/renderFields/RenderPhoneField';
import RenderPinField from '../../../utils/renderFields/RenderPinField';
import RenderSelectField from '../../../utils/renderFields/RenderSelectField';
import RenderTextField from '../../../utils/renderFields/RenderTextField';

import callingCodes from '../../../utils/callingCodes.json';

import bars from '../../../img/bars.svg';
import submit from './submit';
import Terms from '../../signin/Terms';

import { createPhoneCode } from '../signupActions';

const PhoneNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ConfirmationCodeTitle = styled.p`
  text-align: center;
  margin-bottom: 0;
  margin-top: 30px;
  font-size: 1.2em;
  font-weight: 300;
`;

const ActionLink = styled.div`
  text-align: center;
  margin-top: 30px;
  color: ${blue[500]};
  cursor: pointer;
  outline: none;
`;

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(15),
    padding: '20px 40px 40px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

/* eslint-disable import/no-mutable-exports */
let Professional = ({
  handleSubmit,
  createPhoneCodeSuccess,
  dispatchCreatePhoneCode,
  phoneNumber,
  callingCode,
  loading,
  history
}) => {
  const classes = useStyles();
  return (
    <form className={classes.form} onSubmit={handleSubmit(submit)} noValidate>
      <PhoneNumberContainer>
        <Field
          name="callingCode"
          datas={callingCodes}
          id="calling-code"
          component={RenderSelectField}
        />
        <Field
          name="phoneNumber"
          id="phone-field"
          label="Numéro de téléphone"
          component={RenderPhoneField}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                style={{ position: 'relative', right: 5 }}
              >
                {loading ? <img alt="loader" src={bars} width="20" /> : ''}
              </InputAdornment>
            )
          }}
          style={{ width: '70%' }}
          autoFocus
          autoComplete="tel"
        />
      </PhoneNumberContainer>
      <Field
        name="email"
        id="email"
        label="Email"
        fullWidth
        component={RenderTextField}
      />
      <Field
        name="companyName"
        id="company-name"
        label="Nom de l'entreprise"
        fullWidth
        component={RenderTextField}
      />
      <Field
        name="companyRegistrationNumber"
        id="company-registration-number"
        label="Numéro de SIRET"
        fullWidth
        component={RenderTextField}
      />
      <Field
        name="companyVatNumber"
        id="company-vat-number"
        label="Numéro de TVA"
        fullWidth
        component={RenderTextField}
      />

      {createPhoneCodeSuccess ? (
        <>
          <ConfirmationCodeTitle style={{ textAlign: 'center' }}>
            Code de confirmation
          </ConfirmationCodeTitle>
          <Field
            name="confirmationCode"
            id="confirmation-code"
            component={RenderPinField}
            autoFocus
            autoComplete="tel"
          />
          <ActionLink
            role="link"
            tabIndex="0"
            onClick={() => {
              const currentPhoneNumber = parsePhoneNumberFromString(
                `${callingCode}${phoneNumber}`
              );
              dispatchCreatePhoneCode(currentPhoneNumber);
            }}
          >
            Renvoyer le code
          </ActionLink>
        </>
      ) : (
        ''
      )}
      <Terms />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        {createPhoneCodeSuccess ? 'Se connecter' : 'Recevoir mon code'}
      </Button>
      <ActionLink
        role="link"
        tabIndex="0"
        onClick={() => {
          history.push('/signin');
        }}
      >
        Connexion
      </ActionLink>
      <Grid container>
        <Grid item xs />
        <Grid item />
      </Grid>
    </form>
  );
};

const selector = formValueSelector('professionalSingupForm');
const mapStateToProps = state => ({
  initialValues: {
    callingCode: '+33'
  },
  createPhoneCodeSuccess: state.signup.createPhoneCodeSuccess,
  loading: state.signup.loading,
  phoneNumber: selector(state, 'phoneNumber'),
  callingCode: selector(state, 'callingCode')
});

const mapDispatchToProps = {
  dispatchCreatePhoneCode: phoneNumber => createPhoneCode({ phoneNumber })
};

Professional = reduxForm({
  form: 'professionalSingupForm'
})(Professional);

Professional.propTypes = {
  handleSubmit: PropTypes.func,
  phoneNumber: PropTypes.string,
  callingCode: PropTypes.string,
  dispatchCreatePhoneCode: PropTypes.func.isRequired,
  createPhoneCodeSuccess: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Professional)
);
